import { useState, useMemo } from "react";
import { getDaysInMonth, getFirstDayOfMonth } from "./calendarioUtils";

// Encapsula el mini-calendario de días de publicación usado por los modales de Imágenes y Reels
export const useDiasSeleccionados = () => {
    const today = new Date();
    const [calYear, setCalYear] = useState(today.getFullYear());
    const [calMonth, setCalMonth] = useState(today.getMonth());
    const [diasSeleccionados, setDiasSeleccionados] = useState([]);
    const [diasOriginales, setDiasOriginales] = useState([]);

    const prevMonth = () => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); };
    const nextMonth = () => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); };

    const calCells = useMemo(() => {
        const firstDay = getFirstDayOfMonth(calYear, calMonth);
        const daysInMon = getDaysInMonth(calYear, calMonth);
        const prevDays = getDaysInMonth(calYear, calMonth === 0 ? 11 : calMonth - 1);
        const cells = [];
        for (let i = firstDay - 1; i >= 0; i--)
            cells.push({ day: prevDays - i, current: false, month: calMonth === 0 ? 11 : calMonth - 1, year: calMonth === 0 ? calYear - 1 : calYear });
        for (let d = 1; d <= daysInMon; d++)
            cells.push({ day: d, current: true, month: calMonth, year: calYear });
        const remaining = 35 - cells.length;
        for (let d = 1; d <= remaining; d++)
            cells.push({ day: d, current: false, month: calMonth === 11 ? 0 : calMonth + 1, year: calMonth === 11 ? calYear + 1 : calYear });
        return cells;
    }, [calYear, calMonth]);

    const isToday = (cell) =>
        cell.current &&
        cell.day === today.getDate() &&
        cell.month === today.getMonth() &&
        cell.year === today.getFullYear();

    const isDaySelected = (cell) =>
        diasSeleccionados.some(d => d.day === cell.day && d.month === cell.month && d.year === cell.year);

    const isDayOriginal = (cell) =>
        diasOriginales.some(d => d.day === cell.day && d.month === cell.month && d.year === cell.year);

    // Un día ya pasado no se puede agregar como nuevo día de publicación
    const isPastDay = (cell) => {
        const fechaCelda = new Date(cell.year, cell.month, cell.day);
        const hoySinHora = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        return fechaCelda < hoySinHora;
    };

    const toggleDay = (cell) => {
        if (!cell.current) return;
        if (isDaySelected(cell)) {
            setDiasSeleccionados(prev => prev.filter(d => !(d.day === cell.day && d.month === cell.month && d.year === cell.year)));
        } else {
            if (isPastDay(cell)) return;
            setDiasSeleccionados(prev => [...prev, { day: cell.day, month: cell.month, year: cell.year }]);
        }
    };

    // Carga los días ya guardados (modo edición) y posiciona el mini-calendario en el primero
    const hidratar = (dias) => {
        setDiasSeleccionados(dias);
        setDiasOriginales(dias);
        if (dias.length > 0) {
            setCalMonth(dias[0].month);
            setCalYear(dias[0].year);
        }
    };

    const reiniciar = () => {
        setDiasSeleccionados([]);
        setDiasOriginales([]);
        setCalYear(today.getFullYear());
        setCalMonth(today.getMonth());
    };

    return {
        calYear, calMonth, calCells,
        diasSeleccionados, diasOriginales,
        prevMonth, nextMonth,
        isToday, isDaySelected, isDayOriginal, isPastDay, toggleDay,
        hidratar, reiniciar
    };
};